import { Component } from '@angular/core';
import { TopNavComponent } from "./components/top-nav/top-nav.component";
import { SidebarNavComponent } from "./components/sidebar-nav/sidebar-nav.component";
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-intranet',
  standalone: true,
  imports: [RouterOutlet, TopNavComponent, SidebarNavComponent],
  templateUrl: './intranet.component.html',
  styleUrl: './intranet.component.scss'
})
export class IntranetComponent {

}
